export default {
    organizer_supplierFieldSetting: require('../components/organizer/supplierFieldSetting/supplierFieldSettingStore').default,
    organizer_toExhibitsDetail: require('../components/organizer/toExhibitsDetail/toExhibitsDetailStore').default,
    organizer_toSupplierDetail: require('../components/organizer/toSupplierDetail/toSupplierDetailStore').default, //参展商 展商
}


// WEBPACK FOOTER //
// ./src/admin/store/storeModules.js